// extracted by mini-css-extract-plugin
export default {"table":"BulkLogin_table__AwaqX","tableCell":"BulkLogin_tableCell__HwPvT"};